import React from "react";
import { createRoot } from 'react-dom/client';
import App from "./App";
import './index.css';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primeicons/primeicons.css";

console.log('Updated! Version', 7);

const root = createRoot(document.getElementById('root') as HTMLDivElement);
root.render(<App />);
